// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1hbUM","avatar":"style_avatar__3fV07"};